import { ref, onMounted } from 'vue';

// Создаем состояние темы вне функции, чтобы оно было синглтоном
const isDark = ref(false);

export function useTheme() {
  const toggleTheme = () => {
    isDark.value = !isDark.value;
    applyTheme(isDark.value);
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light');
  };

  const applyTheme = (dark) => {
    const html = document.documentElement;
    
    if (dark) {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.removeAttribute('data-theme');
    }
    
    // Добавляем класс для плавных переходов
    html.classList.add('theme-transitioning');
    setTimeout(() => {
      html.classList.remove('theme-transitioning');
    }, 300);
  };

  const setTheme = (theme) => {
    const shouldBeDark = theme === 'dark';
    if (isDark.value !== shouldBeDark) {
      isDark.value = shouldBeDark;
      applyTheme(isDark.value);
      localStorage.setItem('theme', theme);
    }
  };

  const initTheme = () => {
    // Проверяем сохраненную тему
    const savedTheme = localStorage.getItem('theme');
    
    if (savedTheme) {
      isDark.value = savedTheme === 'dark';
    } else {
      // Проверяем системные настройки
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      isDark.value = prefersDark;
      localStorage.setItem('theme', prefersDark ? 'dark' : 'light');
    }
    
    applyTheme(isDark.value);
  };

  // Следим за изменениями системной темы
  const watchSystemTheme = () => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      // Только если пользователь не установил тему вручную
      const savedTheme = localStorage.getItem('theme');
      if (!savedTheme) {
        isDark.value = e.matches;
        applyTheme(isDark.value);
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  };

  onMounted(() => {
    initTheme();
    const cleanup = watchSystemTheme();
    
    // Очистка при размонтировании
    return cleanup;
  });

  return {
    isDark,
    toggleTheme,
    setTheme,
    initTheme
  };
} 